import { render } from "./App.vue?vue&type=template&id=5f4b4d88"
const script = {}

import "./App.vue?vue&type=style&index=0&id=5f4b4d88&lang=scss"
script.render = render

export default script